module.exports = __webpack_public_path__ + "media/images/emoticons/drama-3754ced253df8d23882fe15531130f52.gif";